export default __webpack_public_path__ + "static/media/app-logo-parent.16e09d87.svg";